import { render, staticRenderFns } from "./OrderLink.vue?vue&type=template&id=bf56ad8e"
import script from "./OrderLink.vue?vue&type=script&lang=js"
export * from "./OrderLink.vue?vue&type=script&lang=js"
import style0 from "./OrderLink.vue?vue&type=style&index=0&id=bf56ad8e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports